import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverviewComponent } from './overview.component';
import { OverviewDetailsComponent } from './components/details/details.component';
import { OverviewDetailsResolver } from './components/details/details.routing';
import { RouteReuseNavigationGuard } from 'app/routing/reuse-navigation-guard';
import { SharedOverViewPageModule } from './shared.module';
import { CommonModule } from '@angular/common';
import { KuiModalModule, KuiModule } from 'app/key-ui';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { KeyFilterPanelModule } from 'app/shared/components';
import { LocationSelectModalModule } from 'app/shared/components/modal/location-select-modal/location-select.module';
import { TranslateModule } from '@ngx-translate/core';
import { OverviewStateService } from './services/state.service';
import { VideosService } from '../videos/services/videos.service';
import { AdminEditorModule } from 'app/shared/components/admin/admin.module';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '', component: OverviewComponent, data: { reuse: 'OverviewComponent' }, canActivate: [RouteReuseNavigationGuard],
                children: [
                    {
                        path: ':asset/:tab',
                        component: OverviewDetailsComponent,
                        canDeactivate: [OverviewDetailsResolver],
                        resolve: { params: OverviewDetailsResolver },
                    },
                ],
            },
        ]),
        SharedOverViewPageModule,
        CommonModule,
        KuiModule,
        KuiModalModule,
        SharedModule,
        FormsModule,
        PipeModule.forRoot(),
        KeyFilterPanelModule,
        LocationSelectModalModule,
        TranslateModule.forChild(),
        AdminEditorModule,
    ],
    declarations: [
        OverviewComponent,
    ],
    providers: [
        OverviewStateService,
        VideosService,
    ]
})
export class OverViewPageModule { }
